<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('menu.account_settings') }}
    </div>
    <MerchantInfoItem />
    <div class="line-bottom-1px" />
    <div class="sectionItem">
      <div class="sectionItem_title">{{ $t('system.password') }}</div>
      <div class="sectionItem_name">
        <span class="tip"><el-button type="info" icon="el-icon-key" @click="onClickLoginChange">{{ $t('system.change_your_password') }}</el-button></span>
      </div>
    </div>

    <!-- 目前修改支付密码不写 -->
    <!-- <div class="sectionItem">
      <div class="sectionItem_title">{{ $t('system.pay_password_setting') }}</div>
      <div class="sectionItem_name">
        <span class="tip">Payment password: Use a strong password to ensure your login is secure</span>
        <a class="sectionItem_a" @click="onClickPayChange">{{ $t('components.change') }}</a>
        <a class="sectionItem_a" style="margin-left: 30px" @click="onClickPaySet">{{ $t('components.set') }}</a>
      </div>
      <modify-pay-pwd-modal ref="payPwdModalRef" />
    </div> -->
  </div>

</template>

<script>
export default {
  name: 'System_User_Setting',
  components: {
    MerchantInfoItem: () => import('./components/MerchantInfoItem.vue')
  },
  mounted() {
    const { reset_type, account_type, naire_status, password_expire_time } = this.$store.state.user.userInfo
    if (reset_type === 2) {
      this.tipAndOpenPwdModal()
    }
    // else if (naire_status === 2 && account_type === 1) {
    //   this.tipAndOpenQuestionnaireModal()
    // }

    // this.checkPasswordExpireTime(password_expire_time)
  },
  // 不修改密码，老乡走不了
  // beforeRouteLeave(to, from, next) {
  //   if (to.path === '/questionnaire') {
  //     next()
  //     return
  //   }
  //   const { reset_type, account_type, naire_status, password_expire_time } = this.$store.state.user.userInfo
  //
  //   if (password_expire_time) {
  //     const dateNum = this.getDayDiff(password_expire_time)
  //
  //     if (dateNum <= 0) { // 密码到期强制修改密码
  //       // this.checkPasswordExpireTimeMustModify()
  //       return
  //     }
  //   }
  //
  //   if (this.$router) {
  //     if (reset_type === 2) {
  //       this.tipAndOpenPwdModal()
  //     } else if (naire_status === 2 && account_type === 1) {
  //       this.tipAndOpenQuestionnaireModal()
  //       next()
  //     } else {
  //       next()
  //     }
  //   }
  // },

  methods: {
    tipAndOpenPwdModal() {
      this.$confirm('You must change your password before you can use the system', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.showPwdModal()
      })
    },
    showPwdModal() {
      this.$store.commit('user/SET_MODTIFY_PWD_STATUS', true)
    },
    tipAndOpenQuestionnaireModal() {
      this.$alert('You must finish the Compliance Questionnaire before you activate the account', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$router.push('/questionnaire')
      }).catch(() => {
        this.tipAndOpenQuestionnaireModal()
      })
    },
    onClickLoginChange() {
      this.showPwdModal()
    },
    checkPasswordExpireTime(password_expire_time) {
      if (!password_expire_time) {
        this.checkPasswordExpireTimeLimit3Day(3)
      } else {
        let dateNum = this.getDayDiff(password_expire_time)

        if (dateNum > 0 && dateNum <= 3) {
          dateNum = Math.ceil(dateNum)
          this.checkPasswordExpireTimeLimit3Day(dateNum)
        }
        if (dateNum <= 0) {
          this.checkPasswordExpireTimeMustModify()
        }
      }
    },
    getDayDiff(password_expire_time) {
      if (password_expire_time) {
        const date1 = (new Date()).getTime()
        const date2 = (new Date(password_expire_time + '')).getTime()
        return (date2 - date1) / (1000 * 60 * 60 * 24) // 相减得出的毫秒数除以毫秒除以1分钟60秒除以1小时60分钟，再除以1天24小时
      }
      return 0
    },
    checkPasswordExpireTimeLimit3Day(dateNum) {
      this.$confirm(`The password will expire in ${dateNum} days, please modify it`, 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.showPwdModal()
      })
    },
    checkPasswordExpireTimeMustModify() {
      this.$confirm('The password has expired, please modify it ', 'Tips', {
        confirmButtonText: 'Confirm',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        this.showPwdModal()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .line-bottom-1px{
    margin-top: 40px;
    border-bottom: 1px solid #D3D7DF;
  }
  .tip{
    display: inline-block;
    padding-right: 96px;
    // padding: 40px 0 40px 30px;
  }
  .sectionItem{
    &_title{
      margin-bottom: 32px;
      margin-top: 32px;
      font-size: 18px;
      font-weight: 500;  font-family: 'Inter-Medium';
      color: #3855F1;
    }
    &_name{
      margin-top: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #4B5567;
    }
    &_a{
      cursor: pointer;
      font-size: 20px;
      color:  #98A1B4;
      &:hover{
        color: #3855F1;
      }
    }
    .sectionItem_col-label{
      color: #98A1B4;
      margin-right: 32px;
      display: inline-block;
    }
  }

  @media screen and (max-width: 376px) {
   .sectionItem_name{
    .tip{
      padding-right: 20px;
    }
  }
}

</style>
